<div class="stock-performance-box" (click)="onViewCompanyDetail(stock, last)" [ngClass]="{ first, last }">
  <div class="stock-performance-box-left">
    <div class="logo">
      @if (stock.company.logo) {
        <img [src]="stock.company.logo" alt="" />
      }
      @if (last) {
        <app-ds-icon name="badge-dollar-sign" size="icon-size-3" color="var(--color-core-neutral-7)"></app-ds-icon>
      }
    </div>
    <div class="stock-performance-box-detail">
      <div class="ds-ui-2">{{ stock.company.name | translate }}</div>
      <div>
        <div class="ds-caption-2 ds-color-core-neutral-7">{{ stock.position_value.toFixed(0) | thousand: currency }}</div>
      </div>
    </div>
  </div>
  <div class="stock-performance-box-right" *ngIf="stock.performance">
    <app-ds-returns [value]="stock.performance"></app-ds-returns>
  </div>
</div>
